export const AnalyticsPage = () => {
    return <></>
}